module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0073.jpg?v=49ee7d07";